import { __ } from '@wordpress/i18n'

export default { timeline: __('Timeline', 'dhsv-theme') }
